import { render } from "./ReactivateAccount.vue?vue&type=template&id=770b66d0&scoped=true&lang=pug"
import script from "./ReactivateAccount.vue?vue&type=script&lang=js"
export * from "./ReactivateAccount.vue?vue&type=script&lang=js"

import "./ReactivateAccount.vue?vue&type=style&index=0&id=770b66d0&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770b66d0"]])

export default __exports__